// Generated by KlangScriptProcessor, DO NOT EDIT
@file:Suppress("UNCHECKED_CAST", "UNUSED_PARAMETER", "UnusedImport")

package io.peekandpoke.klang.script.generated

import io.peekandpoke.klang.script.KlangScriptLibrary
import io.peekandpoke.klang.script.annotations.KlangScope
import io.peekandpoke.klang.script.ast.CallInfo
import io.peekandpoke.klang.script.builder.*
import io.peekandpoke.klang.script.runtime.*
import io.peekandpoke.klang.script.types.*

import io.peekandpoke.klang.audio_bridge.AdsrBuilder
import io.peekandpoke.klang.audio_bridge.BandFilterBuilder
import io.peekandpoke.klang.audio_bridge.EqBuilder
import io.peekandpoke.klang.audio_bridge.FilterBuilder
import io.peekandpoke.klang.audio_bridge.FmBuilder
import io.peekandpoke.klang.audio_bridge.IgnitorBandsBuilder
import io.peekandpoke.klang.audio_bridge.IgnitorDsl
import io.peekandpoke.klang.audio_bridge.KatalystBandsBuilder
import io.peekandpoke.klang.audio_bridge.KatalystBodyBuilder
import io.peekandpoke.klang.audio_bridge.KatalystBuilder
import io.peekandpoke.klang.audio_bridge.KatalystDelayBuilder
import io.peekandpoke.klang.audio_bridge.KatalystDsl
import io.peekandpoke.klang.audio_bridge.KatalystEqBuilder
import io.peekandpoke.klang.audio_bridge.KatalystKnobDsl
import io.peekandpoke.klang.audio_bridge.KatalystPhaserBuilder
import io.peekandpoke.klang.audio_bridge.KatalystRampBuilder
import io.peekandpoke.klang.audio_bridge.KatalystSawBuilder
import io.peekandpoke.klang.audio_bridge.KatalystSineBuilder
import io.peekandpoke.klang.audio_bridge.KatalystSquareBuilder
import io.peekandpoke.klang.audio_bridge.KatalystTriBuilder
import io.peekandpoke.klang.audio_bridge.KatalystVowelBuilder
import io.peekandpoke.klang.audio_bridge.ModAdsrBuilder
import io.peekandpoke.klang.audio_bridge.OscImpulseBuilder
import io.peekandpoke.klang.audio_bridge.OscPluckBuilder
import io.peekandpoke.klang.audio_bridge.OscPulzeBuilder
import io.peekandpoke.klang.audio_bridge.OscRampBuilder
import io.peekandpoke.klang.audio_bridge.OscSawBuilder
import io.peekandpoke.klang.audio_bridge.OscSineBuilder
import io.peekandpoke.klang.audio_bridge.OscSquareBuilder
import io.peekandpoke.klang.audio_bridge.OscSuperPluckBuilder
import io.peekandpoke.klang.audio_bridge.OscSuperRampBuilder
import io.peekandpoke.klang.audio_bridge.OscSuperSawBuilder
import io.peekandpoke.klang.audio_bridge.OscSuperSineBuilder
import io.peekandpoke.klang.audio_bridge.OscSuperSquareBuilder
import io.peekandpoke.klang.audio_bridge.OscSuperTriBuilder
import io.peekandpoke.klang.audio_bridge.OscTriBuilder
import io.peekandpoke.klang.audio_bridge.OscZampBuilder
import io.peekandpoke.klang.audio_bridge.OscZawtoothBuilder
import io.peekandpoke.klang.audio_bridge.PhaserBuilder
import io.peekandpoke.klang.audio_bridge.PitchEnvelopeBuilder
import io.peekandpoke.klang.audio_bridge.ShimmerBuilder
import io.peekandpoke.klang.audio_bridge.TremoloBuilder
import io.peekandpoke.klang.audio_bridge.VibratoBuilder
import io.peekandpoke.klang.common.SourceLocation
import io.peekandpoke.klang.script.runtime.ArrayValue
import io.peekandpoke.klang.script.runtime.BooleanValue
import io.peekandpoke.klang.script.runtime.NumberValue
import io.peekandpoke.klang.script.runtime.RuntimeValue
import io.peekandpoke.klang.script.runtime.StringValue
import io.peekandpoke.klang.script.stdlib.E
import io.peekandpoke.klang.script.stdlib.Ign
import io.peekandpoke.klang.script.stdlib.IgnitorDslLike
import io.peekandpoke.klang.script.stdlib.Kat
import io.peekandpoke.klang.script.stdlib.KlangScriptArrayExtensions
import io.peekandpoke.klang.script.stdlib.KlangScriptBooleanExtensions
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitor
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorAdsrCurvesSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorAdsrSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorBpfCurvesSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorBpfSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorCoarseSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorCrushSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorDistortSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorExtensions
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorFmSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorHpfCurvesSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorHpfSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorLpfCurvesSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorLpfSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorNotchCurvesSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorNotchSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorPenvCurvesSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorPenvSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorTremoloSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorVibratoSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalyst
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystBodySlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystCompressorSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystDelaySlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystDuckSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystGainSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystPhaserSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystReverbSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptKatalystVowelSlots
import io.peekandpoke.klang.script.stdlib.KlangScriptMath
import io.peekandpoke.klang.script.stdlib.KlangScriptNumberExtensions
import io.peekandpoke.klang.script.stdlib.KlangScriptObjectUtility
import io.peekandpoke.klang.script.stdlib.KlangScriptStringExtensions
import io.peekandpoke.klang.script.stdlib.PI
import io.peekandpoke.klang.script.stdlib.scriptAbs
import io.peekandpoke.klang.script.stdlib.scriptAdd
import io.peekandpoke.klang.script.stdlib.scriptAdsr
import io.peekandpoke.klang.script.stdlib.scriptAnalog
import io.peekandpoke.klang.script.stdlib.scriptAnalogSpread
import io.peekandpoke.klang.script.stdlib.scriptBand
import io.peekandpoke.klang.script.stdlib.scriptBands
import io.peekandpoke.klang.script.stdlib.scriptBlend
import io.peekandpoke.klang.script.stdlib.scriptBody
import io.peekandpoke.klang.script.stdlib.scriptBrightness
import io.peekandpoke.klang.script.stdlib.scriptCap
import io.peekandpoke.klang.script.stdlib.scriptCenterJitter
import io.peekandpoke.klang.script.stdlib.scriptClassic
import io.peekandpoke.klang.script.stdlib.scriptCompressor
import io.peekandpoke.klang.script.stdlib.scriptCurves
import io.peekandpoke.klang.script.stdlib.scriptCut
import io.peekandpoke.klang.script.stdlib.scriptDeclick
import io.peekandpoke.klang.script.stdlib.scriptDelay
import io.peekandpoke.klang.script.stdlib.scriptDistort
import io.peekandpoke.klang.script.stdlib.scriptDiv
import io.peekandpoke.klang.script.stdlib.scriptDuck
import io.peekandpoke.klang.script.stdlib.scriptDuty
import io.peekandpoke.klang.script.stdlib.scriptEnv
import io.peekandpoke.klang.script.stdlib.scriptEq
import io.peekandpoke.klang.script.stdlib.scriptFallFlank
import io.peekandpoke.klang.script.stdlib.scriptFeedback
import io.peekandpoke.klang.script.stdlib.scriptFlankSamples
import io.peekandpoke.klang.script.stdlib.scriptFloor
import io.peekandpoke.klang.script.stdlib.scriptFundamental
import io.peekandpoke.klang.script.stdlib.scriptGain
import io.peekandpoke.klang.script.stdlib.scriptGainJitter
import io.peekandpoke.klang.script.stdlib.scriptHarmonics
import io.peekandpoke.klang.script.stdlib.scriptHumanize
import io.peekandpoke.klang.script.stdlib.scriptLimiter
import io.peekandpoke.klang.script.stdlib.scriptMax
import io.peekandpoke.klang.script.stdlib.scriptMin
import io.peekandpoke.klang.script.stdlib.scriptMinus
import io.peekandpoke.klang.script.stdlib.scriptMul
import io.peekandpoke.klang.script.stdlib.scriptNeg
import io.peekandpoke.klang.script.stdlib.scriptNegate
import io.peekandpoke.klang.script.stdlib.scriptOctaves
import io.peekandpoke.klang.script.stdlib.scriptOversampleAtLeast
import io.peekandpoke.klang.script.stdlib.scriptOversampleBy
import io.peekandpoke.klang.script.stdlib.scriptParallel
import io.peekandpoke.klang.script.stdlib.scriptPartial
import io.peekandpoke.klang.script.stdlib.scriptPasses
import io.peekandpoke.klang.script.stdlib.scriptPhase
import io.peekandpoke.klang.script.stdlib.scriptPhasePool
import io.peekandpoke.klang.script.stdlib.scriptPhaser
import io.peekandpoke.klang.script.stdlib.scriptPickPosition
import io.peekandpoke.klang.script.stdlib.scriptPlus
import io.peekandpoke.klang.script.stdlib.scriptPow
import io.peekandpoke.klang.script.stdlib.scriptPower
import io.peekandpoke.klang.script.stdlib.scriptRange
import io.peekandpoke.klang.script.stdlib.scriptResetSamples
import io.peekandpoke.klang.script.stdlib.scriptReverb
import io.peekandpoke.klang.script.stdlib.scriptRiseFlank
import io.peekandpoke.klang.script.stdlib.scriptSerial
import io.peekandpoke.klang.script.stdlib.scriptShape
import io.peekandpoke.klang.script.stdlib.scriptShapeMax
import io.peekandpoke.klang.script.stdlib.scriptSideAtten
import io.peekandpoke.klang.script.stdlib.scriptSpread
import io.peekandpoke.klang.script.stdlib.scriptSpreadPower
import io.peekandpoke.klang.script.stdlib.scriptStiffness
import io.peekandpoke.klang.script.stdlib.scriptSub
import io.peekandpoke.klang.script.stdlib.scriptSuboctaves
import io.peekandpoke.klang.script.stdlib.scriptTap
import io.peekandpoke.klang.script.stdlib.scriptTimes
import io.peekandpoke.klang.script.stdlib.scriptVoices
import io.peekandpoke.klang.script.stdlib.scriptVowel

internal fun KlangScriptExtensionBuilder.registerStdlibKlangScriptIgnitorChunk0() {

    // @Object("Ignitor") on KlangScriptIgnitor
    registerObject("Ignitor", KlangScriptIgnitor) {
        registerMethod<IgnitorDsl>("freq", emptyList()) { KlangScriptIgnitor.freq() }
        registerMethod<IgnitorDsl>("progress", emptyList()) { KlangScriptIgnitor.progress() }
        registerMethod<IgnitorDsl>("elapsed", emptyList()) { KlangScriptIgnitor.elapsed() }
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "sine",
            paramSpecs = listOf(
                ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "configure", kotlinType = Function1::class, isNullable = true, isOptional = true, default = nullDefault)
            ),
        ) { receiver, args, loc ->
            checkArgsSize(fn = "sine", args = args, expected = 0, location = loc)
            wrapAsRuntimeValue(
                KlangScriptIgnitor.sine(
                    freq = optArg(args, 0, Any::class, loc),
                    configure = optArg(args, 1, Function1::class, loc) as ((OscSineBuilder) -> OscSineBuilder)?,
                )
            )
        }
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "saw",
            paramSpecs = listOf(
                ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "configure", kotlinType = Function1::class, isNullable = true, isOptional = true, default = nullDefault)
            ),
        ) { receiver, args, loc ->
            checkArgsSize(fn = "saw", args = args, expected = 0, location = loc)
            wrapAsRuntimeValue(
                KlangScriptIgnitor.saw(
                    freq = optArg(args, 0, Any::class, loc),
                    configure = optArg(args, 1, Function1::class, loc) as ((OscSawBuilder) -> OscSawBuilder)?,
                )
            )
        }
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "square",
            paramSpecs = listOf(
                ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "configure", kotlinType = Function1::class, isNullable = true, isOptional = true, default = nullDefault)
            ),
        ) { receiver, args, loc ->
            checkArgsSize(fn = "square", args = args, expected = 0, location = loc)
            wrapAsRuntimeValue(
                KlangScriptIgnitor.square(
                    freq = optArg(args, 0, Any::class, loc),
                    configure = optArg(args, 1, Function1::class, loc) as ((OscSquareBuilder) -> OscSquareBuilder)?,
                )
            )
        }
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "tri",
            paramSpecs = listOf(
                ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "configure", kotlinType = Function1::class, isNullable = true, isOptional = true, default = nullDefault)
            ),
        ) { receiver, args, loc ->
            checkArgsSize(fn = "tri", args = args, expected = 0, location = loc)
            wrapAsRuntimeValue(
                KlangScriptIgnitor.tri(
                    freq = optArg(args, 0, Any::class, loc),
                    configure = optArg(args, 1, Function1::class, loc) as ((OscTriBuilder) -> OscTriBuilder)?,
                )
            )
        }
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "ramp",
            paramSpecs = listOf(
                ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "configure", kotlinType = Function1::class, isNullable = true, isOptional = true, default = nullDefault)
            ),
        ) { receiver, args, loc ->
            checkArgsSize(fn = "ramp", args = args, expected = 0, location = loc)
            wrapAsRuntimeValue(
                KlangScriptIgnitor.ramp(
                    freq = optArg(args, 0, Any::class, loc),
                    configure = optArg(args, 1, Function1::class, loc) as ((OscRampBuilder) -> OscRampBuilder)?,
                )
            )
        }
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "zawtooth",
            paramSpecs = listOf(
                ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "configure", kotlinType = Function1::class, isNullable = true, isOptional = true, default = nullDefault)
            ),
        ) { receiver, args, loc ->
            checkArgsSize(fn = "zawtooth", args = args, expected = 0, location = loc)
            wrapAsRuntimeValue(
                KlangScriptIgnitor.zawtooth(
                    freq = optArg(args, 0, Any::class, loc),
                    configure = optArg(args, 1, Function1::class, loc) as ((OscZawtoothBuilder) -> OscZawtoothBuilder)?,
                )
            )
        }
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "zamp",
            paramSpecs = listOf(
                ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "configure", kotlinType = Function1::class, isNullable = true, isOptional = true, default = nullDefault)
            ),
        ) { receiver, args, loc ->
            checkArgsSize(fn = "zamp", args = args, expected = 0, location = loc)
            wrapAsRuntimeValue(
                KlangScriptIgnitor.zamp(
                    freq = optArg(args, 0, Any::class, loc),
                    configure = optArg(args, 1, Function1::class, loc) as ((OscZampBuilder) -> OscZampBuilder)?,
                )
            )
        }
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "impulse",
            paramSpecs = listOf(
                ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "configure", kotlinType = Function1::class, isNullable = true, isOptional = true, default = nullDefault)
            ),
        ) { receiver, args, loc ->
            checkArgsSize(fn = "impulse", args = args, expected = 0, location = loc)
            wrapAsRuntimeValue(
                KlangScriptIgnitor.impulse(
                    freq = optArg(args, 0, Any::class, loc),
                    configure = optArg(args, 1, Function1::class, loc) as ((OscImpulseBuilder) -> OscImpulseBuilder)?,
                )
            )
        }
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "pulze",
            paramSpecs = listOf(
                ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "configure", kotlinType = Function1::class, isNullable = true, isOptional = true, default = nullDefault)
            ),
        ) { receiver, args, loc ->
            checkArgsSize(fn = "pulze", args = args, expected = 0, location = loc)
            wrapAsRuntimeValue(
                KlangScriptIgnitor.pulze(
                    freq = optArg(args, 0, Any::class, loc),
                    configure = optArg(args, 1, Function1::class, loc) as ((OscPulzeBuilder) -> OscPulzeBuilder)?,
                )
            )
        }
        registerMethod<IgnitorDsl>("silence", emptyList()) { KlangScriptIgnitor.silence() }
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "whitenoise",
            paramSpecs = listOf(
                ParamSpec(name = "color", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(0.0) })
            ),
        ) { receiver, args, loc ->
            checkArgsSize(fn = "whitenoise", args = args, expected = 0, location = loc)
            wrapAsRuntimeValue(
                KlangScriptIgnitor.whitenoise(
                    color = if (args.size > 0) convertArgToKotlin(fn = "whitenoise", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any else 0.0,
                )
            )
        }
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "brownnoise",
            paramSpecs = listOf(
                ParamSpec(name = "leak", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(0.02) })
            ),
        ) { receiver, args, loc ->
            checkArgsSize(fn = "brownnoise", args = args, expected = 0, location = loc)
            wrapAsRuntimeValue(
                KlangScriptIgnitor.brownnoise(
                    leak = if (args.size > 0) convertArgToKotlin(fn = "brownnoise", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any else 0.02,
                )
            )
        }
        registerMethod<IgnitorDsl>("pinknoise", emptyList()) { KlangScriptIgnitor.pinknoise() }
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "perlin",
            paramSpecs = listOf(
                ParamSpec(name = "rate", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(1.0) }),
                ParamSpec(name = "octaves", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(1.0) }),
                ParamSpec(name = "persistence", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(0.5) })
            ),
        ) { receiver, args, loc ->
            checkArgsSize(fn = "perlin", args = args, expected = 0, location = loc)
            wrapAsRuntimeValue(
                KlangScriptIgnitor.perlin(
                    rate = if (args.size > 0) convertArgToKotlin(fn = "perlin", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any else 1.0,
                    octaves = if (args.size > 1) convertArgToKotlin(fn = "perlin", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any else 1.0,
                    persistence = if (args.size > 2) convertArgToKotlin(fn = "perlin", args = args, index = 2, cls = Any::class, nullable = false, loc = loc) as Any else 0.5,
                )
            )
        }
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "berlin",
            paramSpecs = listOf(
                ParamSpec(name = "rate", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(1.0) }),
                ParamSpec(name = "octaves", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(1.0) }),
                ParamSpec(name = "persistence", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(0.5) })
            ),
        ) { receiver, args, loc ->
            checkArgsSize(fn = "berlin", args = args, expected = 0, location = loc)
            wrapAsRuntimeValue(
                KlangScriptIgnitor.berlin(
                    rate = if (args.size > 0) convertArgToKotlin(fn = "berlin", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any else 1.0,
                    octaves = if (args.size > 1) convertArgToKotlin(fn = "berlin", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any else 1.0,
                    persistence = if (args.size > 2) convertArgToKotlin(fn = "berlin", args = args, index = 2, cls = Any::class, nullable = false, loc = loc) as Any else 0.5,
                )
            )
        }
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "dust",
            paramSpecs = listOf(
                ParamSpec(name = "density", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(0.2) }),
                ParamSpec(name = "tail", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(1.0) }),
                ParamSpec(name = "bipolar", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(0.0) })
            ),
        ) { receiver, args, loc ->
            checkArgsSize(fn = "dust", args = args, expected = 0, location = loc)
            wrapAsRuntimeValue(
                KlangScriptIgnitor.dust(
                    density = if (args.size > 0) convertArgToKotlin(fn = "dust", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any else 0.2,
                    tail = if (args.size > 1) convertArgToKotlin(fn = "dust", args = args, index = 1, cls = Any::class, nullable = false, loc = loc) as Any else 1.0,
                    bipolar = if (args.size > 2) convertArgToKotlin(fn = "dust", args = args, index = 2, cls = Any::class, nullable = false, loc = loc) as Any else 0.0,
                )
            )
        }
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "crackle",
            paramSpecs = listOf(
                ParamSpec(name = "chaos", kotlinType = Any::class, isOptional = true, default = { wrapAsRuntimeValue(1.5) })
            ),
        ) { receiver, args, loc ->
            checkArgsSize(fn = "crackle", args = args, expected = 0, location = loc)
            wrapAsRuntimeValue(
                KlangScriptIgnitor.crackle(
                    chaos = if (args.size > 0) convertArgToKotlin(fn = "crackle", args = args, index = 0, cls = Any::class, nullable = false, loc = loc) as Any else 1.5,
                )
            )
        }
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "supersaw",
            paramSpecs = listOf(
                ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "configure", kotlinType = Function1::class, isNullable = true, isOptional = true, default = nullDefault)
            ),
        ) { receiver, args, loc ->
            checkArgsSize(fn = "supersaw", args = args, expected = 0, location = loc)
            wrapAsRuntimeValue(
                KlangScriptIgnitor.supersaw(
                    freq = optArg(args, 0, Any::class, loc),
                    configure = optArg(args, 1, Function1::class, loc) as ((OscSuperSawBuilder) -> OscSuperSawBuilder)?,
                )
            )
        }
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "supersine",
            paramSpecs = listOf(
                ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "configure", kotlinType = Function1::class, isNullable = true, isOptional = true, default = nullDefault)
            ),
        ) { receiver, args, loc ->
            checkArgsSize(fn = "supersine", args = args, expected = 0, location = loc)
            wrapAsRuntimeValue(
                KlangScriptIgnitor.supersine(
                    freq = optArg(args, 0, Any::class, loc),
                    configure = optArg(args, 1, Function1::class, loc) as ((OscSuperSineBuilder) -> OscSuperSineBuilder)?,
                )
            )
        }
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "supersquare",
            paramSpecs = listOf(
                ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "configure", kotlinType = Function1::class, isNullable = true, isOptional = true, default = nullDefault)
            ),
        ) { receiver, args, loc ->
            checkArgsSize(fn = "supersquare", args = args, expected = 0, location = loc)
            wrapAsRuntimeValue(
                KlangScriptIgnitor.supersquare(
                    freq = optArg(args, 0, Any::class, loc),
                    configure = optArg(args, 1, Function1::class, loc) as ((OscSuperSquareBuilder) -> OscSuperSquareBuilder)?,
                )
            )
        }
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "supertri",
            paramSpecs = listOf(
                ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "configure", kotlinType = Function1::class, isNullable = true, isOptional = true, default = nullDefault)
            ),
        ) { receiver, args, loc ->
            checkArgsSize(fn = "supertri", args = args, expected = 0, location = loc)
            wrapAsRuntimeValue(
                KlangScriptIgnitor.supertri(
                    freq = optArg(args, 0, Any::class, loc),
                    configure = optArg(args, 1, Function1::class, loc) as ((OscSuperTriBuilder) -> OscSuperTriBuilder)?,
                )
            )
        }
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "superramp",
            paramSpecs = listOf(
                ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "configure", kotlinType = Function1::class, isNullable = true, isOptional = true, default = nullDefault)
            ),
        ) { receiver, args, loc ->
            checkArgsSize(fn = "superramp", args = args, expected = 0, location = loc)
            wrapAsRuntimeValue(
                KlangScriptIgnitor.superramp(
                    freq = optArg(args, 0, Any::class, loc),
                    configure = optArg(args, 1, Function1::class, loc) as ((OscSuperRampBuilder) -> OscSuperRampBuilder)?,
                )
            )
        }
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "pluck",
            paramSpecs = listOf(
                ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "configure", kotlinType = Function1::class, isNullable = true, isOptional = true, default = nullDefault)
            ),
        ) { receiver, args, loc ->
            checkArgsSize(fn = "pluck", args = args, expected = 0, location = loc)
            wrapAsRuntimeValue(
                KlangScriptIgnitor.pluck(
                    freq = optArg(args, 0, Any::class, loc),
                    configure = optArg(args, 1, Function1::class, loc) as ((OscPluckBuilder) -> OscPluckBuilder)?,
                )
            )
        }
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "superpluck",
            paramSpecs = listOf(
                ParamSpec(name = "freq", kotlinType = Any::class, isNullable = true, isOptional = true, default = nullDefault),
                ParamSpec(name = "configure", kotlinType = Function1::class, isNullable = true, isOptional = true, default = nullDefault)
            ),
        ) { receiver, args, loc ->
            checkArgsSize(fn = "superpluck", args = args, expected = 0, location = loc)
            wrapAsRuntimeValue(
                KlangScriptIgnitor.superpluck(
                    freq = optArg(args, 0, Any::class, loc),
                    configure = optArg(args, 1, Function1::class, loc) as ((OscSuperPluckBuilder) -> OscSuperPluckBuilder)?,
                )
            )
        }
        builder.registerExtensionMethodWithSpecs(
            receiver = cls,
            name = "param",
            paramSpecs = listOf(
                ParamSpec(name = "name", kotlinType = String::class),
                ParamSpec(name = "default", kotlinType = Double::class),
                ParamSpec(name = "description", kotlinType = String::class, isOptional = true, default = { wrapAsRuntimeValue("") })
            ),
        ) { receiver, args, loc ->
            checkArgsSize(fn = "param", args = args, expected = 2, location = loc)
            val name = convertArgToKotlin(fn = "param", args = args, index = 0, cls = String::class, nullable = false, loc = loc) as String
            val default = convertArgToKotlin(fn = "param", args = args, index = 1, cls = Double::class, nullable = false, loc = loc) as Double
            wrapAsRuntimeValue(
                KlangScriptIgnitor.param(
                    name = name,
                    default = default,
                    description = if (args.size > 2) convertArgToKotlin(fn = "param", args = args, index = 2, cls = String::class, nullable = false, loc = loc) as String else "",
                )
            )
        }
        registerMethod<Double, IgnitorDsl>("constant", listOf(
                ParamSpec(name = "value", kotlinType = Double::class)
            )) { value -> KlangScriptIgnitor.constant(value = value) }
        registerMethod<((IgnitorDsl) -> IgnitorDsl), ((IgnitorDsl) -> IgnitorDsl)>("fn", listOf(
                ParamSpec(name = "f", kotlinType = Function1::class)
            )) { f -> KlangScriptIgnitor.fn(f = f) }
        registerVarargMethod<Any, IgnitorDsl>("variants") { args -> KlangScriptIgnitor.variants(*args.toTypedArray()) }
        registerProperty("slot") { KlangScriptIgnitor.slot }
    }
}

internal fun KlangScriptExtensionBuilder.registerStdlibKlangScriptIgnitorChunk1() {

    // @Property on Ign
    registerObject("Ign", Ign)
}

